import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const TOAST_Z_INDEX = 2147483647;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="bottom-right"
      expand
      visibleToasts={5}
      richColors
      closeButton
      toastOptions={{
        style: { zIndex: TOAST_Z_INDEX },
        duration: 4000,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "!bg-[#f0fdf4] group-[.toaster]:text-foreground group-[.toaster]:border-success/50 [&>svg]:text-success",
          error: "!bg-[#fef2f2] group-[.toaster]:text-foreground group-[.toaster]:border-destructive/50 [&>svg]:text-destructive",
          warning: "!bg-[#fffbeb] group-[.toaster]:text-foreground group-[.toaster]:border-warning/50 [&>svg]:text-warning",
          info: "!bg-[#eff6ff] group-[.toaster]:text-foreground group-[.toaster]:border-primary/50 [&>svg]:text-primary",
        },
      }}
      {...props}
      style={{ zIndex: TOAST_Z_INDEX, ...props.style }}
    />
  );
};

export { Toaster, toast };
